<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'LOGIN' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <form (ngSubmit)="login()" #loginForm="ngForm">
    <ion-list>
      <ion-item>
        <ion-input label="{{ 'EMAIL' | translate }}" labelPlacement="floating" type="email" [(ngModel)]="email"
          name="email" required email #emailCtrl="ngModel"></ion-input>
      </ion-item>
      <ion-item>
        <ion-input label="{{ 'PASSWORD' | translate }}" labelPlacement="floating" type="password" [(ngModel)]="password"
          name="password" required></ion-input>
      </ion-item>
    </ion-list>

    <ion-note color="danger" *ngIf="loginError" class="ion-padding-start">
      {{ loginError }}
    </ion-note>

    <div class="ion-padding-top" class="logsign">
      <ion-button type="submit" [disabled]="loginForm.invalid || isSubmitting" class="login" color="tertiary">
        <ion-spinner *ngIf="isSubmitting" name="crescent"></ion-spinner>
        <span *ngIf="!isSubmitting">{{ 'LOGIN' | translate }}</span>
      </ion-button>
      <ion-button routerLink="/registration" (click)="closeModal()">
        {{ 'SIGN_UP' | translate }}
      </ion-button>
    </div>
  </form>

  <div class="ion-text-center">
    <a (click)="openForgotPasswordModal()" class="forgot-password-link">{{ 'FORGOT_PASSWORD' | translate }}</a>
  </div>
</ion-content>